import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BackResponse, BackResponseFailure } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}additionalInformation/entities`;

export interface AdditionalInformationEntitySummary {
  id: string;
}

export interface LocalizedAdditionalInformation {
  additionalInformationEntity: AdditionalInformationEntitySummary;
  label?: string;
}

export interface GetAdditionalInformationEntitiesSummariesRequestArgs {
  ids: string[];
  cultureName: string;
}

export const getAdditionalInformationEntitiesSummariesRequest = ({
  ids,
  cultureName,
}: GetAdditionalInformationEntitiesSummariesRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { ids, countryCode: cultureName },
  },
});

export const getAdditionalInformationEntitiesSummariesCommand = async (
  payload: GetAdditionalInformationEntitiesSummariesRequestArgs,
): Promise<
  BackResponse<LocalizedAdditionalInformation[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<LocalizedAdditionalInformation[]>>(
      getAdditionalInformationEntitiesSummariesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
